import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import z from "zod";
import { taskCommentsAddition, tasksUpdation } from "./tasksSlice";
import { fetchMilestones, updateTaskFlag } from "../actions/milestoneSlice";
import { fetchProccessId } from "../actions/processSlice";
import useDateTime from "~/hooks/useDateTime";
import API_ROUTES from "~/api-routes";
import apiService from "~/services/service";
import useFileUpload from "~/utils/useFileUpload";

function useTasks() {
  const dispatch = useDispatch();
  const { id } = useParams();
  const [isTaskUpdateLoad, setIsTaskUpdateLoad] = useState(false);
  const [flagForm, setFlagForm] = useState({});
  const [isaddflagmodal, setIsAddFlagModal] = useState(false);
  const [isremoveFlag, setIsRemoveFlag] = useState(false);
  const [isUnflagload, setIsUnFlagload] = useState(false);
  const [isLoadStatus, setIsLoadStatus] = useState(false);
  const [isLoadDate, setIsLoadDate] = useState(false);
  const [isLoadOwner, setIsLoadOwner] = useState(false);
  const [isCommentsLoading, setIsCommentsLoading] = useState(false);
  const [isSuccessComment, setIsSuccessComment] = useState(false);
  const [isCommentError, setIsCommentError] = useState(false);
  const [errorMessage, setErrorMessage] = useState({ summary: "", detail: "" });
  const { dateTimeToTimezone } = useDateTime();

  const [selectedOwners, setSelectedOwners] = useState({});
  const [selectedStatuses, setSelectedStatuses] = useState({});
  const [selectedTask, setSelectedTask] = useState({});
  const [dueDate, setDueDate] = useState({});
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [flag_comment, setFlagComment] = useState("");
  const [isTaskCommentModal, setIsTaskCommentModal] = useState(false);
  const [taskCommentData, setTaskCommentData] = useState(null);
  const [files, setFiles] = useState([]);
  const { uploadFile, uuidToUlid, SERVICE_CODES, getFileVersion, updateTag } =
    useFileUpload();
  const { id: userId } = useSelector((state) => state.login);
  const process = useSelector((state) => state.process);
  const { entityservices } = useSelector((state) => state.globalEntities);

  const [totalCommentCount, setTotalCommentCount] = useState(0);
  const [isCommentLoading, setIsCommentLoading] = useState(false);
  const [commentList, setCommentList] = useState([]);
  const [commentListPage, setCommentListPage] = useState(0);
  const [hasMoreComments, setHasMoreComments] = useState(true);
  const [showAttachmentConfirmation, setShowAttachmentConfirmation] =
    useState(false);
  const [isRejectPayslip, setIsRejectPayslip] = useState(false);
  const [showInitialCard, setShowInitialCard] = useState(false);

  const handleCloseFlagModal = () => {
    setFlagComment("");
    setFlagForm({});
    setIsAddFlagModal(false);
    if (isremoveFlag) {
      setIsUnFlagload(false);
      setIsRemoveFlag(false);
    }
  };

  const handleAddFlag = (data, isRemove) => {
    setFlagForm(data);
    setIsAddFlagModal(true);
    setIsRemoveFlag(isRemove);
  };
  const handleChangeFlag = (e) => {
    setFlagComment(e.target.value);
    setFlagForm((prevState) => ({
      ...prevState,
      [e.target.name]: e.target.value,
    }));
  };

  const addTaskCommentModalHandler = (task) => {
    setIsTaskCommentModal(true);
  };

  const closeTaskCommentModalHandler = () => {
    setIsTaskCommentModal(false);
    setFiles([]);
    setTaskCommentData(null);
    setIsCommentsLoading(false);
    setIsSuccessComment(false);
  };

  const taskCommentChangeHandler = (e, key) => {
    const value = key === "type" ? e.target.value.code : e.target.value;
    setTaskCommentData((prev) => ({
      ...prev,
      [key]: value,
    }));
  };
  const getService = (service) => {
    return entityservices.find((x) => x.id === service);
  };
  const serviceLine = entityservices.find(
    (x) => x.id === process?.service,
  )?.name;
  const addTaskComment = async (
    taskId,
    paySlipMatchingResult = [],
    processmilestones = {},
  ) => {
    try {
      setIsCommentsLoading(true);
      setIsCommentError(false);
      const attachments = [];
      for (let i = 0; i < files.length; i++) {
        const file = files[i].file;
        const service = getService(process?.processdata?.service)?.name;
        const tags = {
          year: new Date().getFullYear().toString(),
          entity: uuidToUlid(process?.processdata?.entity),
          service: SERVICE_CODES[service],
          process: uuidToUlid(id),
          country: process?.processdata?.entityData?.country,
          category: file?.category,
          subCategory: file?.subCategory,
          temporary_file: "false",
          is_public:
            taskCommentData?.type && taskCommentData?.type === "internal"
              ? "false"
              : "true",
        };
        const version =
          file?.versionNumber.toString() || `${await getFileVersion(tags)}`;
        let metaData = {
          original_file_name: encodeURIComponent(file.name),
          file_size: file.size.toString(),
          file_type: file.type,
          user: userId,
          file_name: file.fileName,
          version,
          created_at: new Date().toISOString(),
          file_object_type: "TASK",
          taskId: uuidToUlid(taskId),
          ...(file?.description && {
            description: encodeURIComponent(file?.description),
          }),
        };
        const uploadData = await uploadFile(file, file.fileName, {
          entityId: process?.processdata?.entity,
          serviceLineCode:
            SERVICE_CODES[getService(process?.processdata?.service)?.name],
          fileName: file.fileName,
        });
        metaData = { ...metaData, url: uploadData.url };
        attachments.push({ url: uploadData.url, fileName: uploadData.id });
        await updateTag(uploadData.id, tags, metaData);
      }
      const data = {
        id: taskId,
        type: "TASK",
        isPublic:
          taskCommentData?.type && taskCommentData?.type === "internal"
            ? false
            : true,
        comment: taskCommentData?.comment,
        attachments: attachments,
      };
      const { payload } = await dispatch(taskCommentsAddition(data));

      if (payload?.status) {
        setTimeout(async () => {
          setShowAttachmentConfirmation(false);
          dispatch(fetchProccessId(id));
          !isRejectPayslip && dispatch(fetchMilestones(id));
          if (isRejectPayslip) {
            await handlePayslipInitialCard(
              paySlipMatchingResult,
              processmilestones,
            );
          }
          setIsTaskCommentModal(true);
          setIsSuccessComment(true);
          setIsCommentsLoading(false);
          setFiles([]);
        }, 900);
      } else {
        setIsCommentError(true);
        setErrorMessage({
          summary: "Failed to save comment. ",
          detail: "Please try again.",
        });
        setIsCommentsLoading(false);
        console.error(payload);
      }
    } catch (err) {
      setIsCommentError(true);
      setErrorMessage({
        summary: "Failed to upload file. ",
        detail: "Please try again.",
      });
      setIsCommentsLoading(false);
      console.error("An error occurred while adding a comment:", err.message);
    }
  };

  const handlePayslipInitialCard = async (
    paySlipMatchingResult,
    processmilestones,
  ) => {
    try {
      setShowInitialCard(true);
      paySlipMatchingResult.forEach(
        (fileItem) => (fileItem.match_status = "rejected"),
      );
      await updatePayslipMatchingResult(paySlipMatchingResult);
      const templateData = process?.processdata?.templateData;
      const milestone = templateData?.template?.find(
        (milestone) => milestone.name === "Submit Final Output",
      );
      const task = milestone?.tasks?.find(
        (task) => task.name === "Submit final output to Customer",
      );
      const result =
        processmilestones
          ?.flatMap((milestone) => milestone.taskData || [])
          .find((task) => task.name === "Submit final output to Customer") ||
        task;
      if (result) {
        await handleStatusChange(
          { code: "not-started", name: "Not Started" },
          result,
          null,
          isRejectPayslip,
        );
        setIsRejectPayslip(false);
      }
    } catch (err) {
      console.error(err);
    }
  };

  const updatePayslipMatchingResult = async (matchedFiles) => {
    try {
      return await apiService(
        API_ROUTES.UPDATE_PAYSLIP_MATCHING_RESULTS,
        "PATCH",
        {
          body: { matchedFiles, updateMessage: false },
        },
      );
    } catch (error) {
      console.error("Error updating payslip matching result:", error);
    }
  };

  const removeFlagTaskUpdate = (data) => {
    setIsUnFlagload(true);
    setIsTaskUpdateLoad(true);
    dispatch(tasksUpdation({ ...data, flag: false })).then(({ payload }) => {
      if (payload?.status) {
        setTimeout(() => {
          // Update local state instead of re-fetching to maintain milestone order
          dispatch(updateTaskFlag({ taskId: data.id, flagStatus: false }));
          dispatch(fetchProccessId(id));
          setIsTaskUpdateLoad(false);
          handleCloseFlagModal();
        }, 900);
      }
    });
  };

  const taskUpdate = (data) => {
    if (isremoveFlag) {
      removeFlagTaskUpdate(data);
    } else {
      const latestFlaggedAt = new Date().toISOString();
      data["latest_flagged_at"] = latestFlaggedAt;
      setIsTaskUpdateLoad(true);
      dispatch(tasksUpdation(data)).then(({ payload }) => {
        if (payload?.status) {
          setTimeout(() => {
            // Update local state instead of re-fetching to maintain milestone order
            dispatch(
              updateTaskFlag({
                taskId: data.id,
                flagStatus: true,
                latestFlaggedAt,
              }),
            );
            dispatch(fetchProccessId(id));
            setIsTaskUpdateLoad(false);
            handleCloseFlagModal();
          }, 900);
        }
      });
    }
  };

  const handleStatusChange = (
    value,
    rowdata,
    callback,
    isRejectPayslip = false,
  ) => {
    callback = callback || null;
    setIsLoadStatus(true);
    !isRejectPayslip && setSelectedTask(rowdata);
    const now = new Date();
    const completed_at =
      value?.code === "completed" ? dateTimeToTimezone({ date: now }) : null;
    const in_progress_at =
      value?.code === "in-progress" ? dateTimeToTimezone({ date: now }) : null;
    dispatch(
      tasksUpdation({
        ...rowdata,
        status: value?.code,
        completed_at,
        in_progress_at,
      }),
    ).then(({ payload }) => {
      if (payload?.status) {
        setTimeout(async () => {
          await dispatch(fetchMilestones({ id, skipCache: true }));
          await dispatch(fetchProccessId({ id, skipCache: true }));
          setIsLoadStatus(false);
          !isRejectPayslip && setSelectedTask({});
          callback && callback();
        }, 900);
      }
    });
  };
  const handleMarkedAsComplete = (rowdata) => {
    setIsLoadStatus(true);
    setSelectedTask(rowdata);
    dispatch(tasksUpdation({ ...rowdata, status: "completed" })).then(
      ({ payload }) => {
        if (payload?.status) {
          setTimeout(() => {
            dispatch(fetchMilestones({ id, skipCache: true }));
            dispatch(fetchProccessId({ id, skipCache: true }));
            setIsLoadStatus(false);
            setSelectedTask({});
          }, 900);
        }
      },
    );
  };

  const handleDueDateChange = (value, rowdata) => {
    setIsLoadDate(true);
    setSelectedTask(rowdata);
    dispatch(tasksUpdation({ ...rowdata, due_date: value })).then(
      ({ payload }) => {
        if (payload?.status) {
          setTimeout(() => {
            dispatch(fetchMilestones({ id, skipCache: true }));
            dispatch(fetchProccessId({ id, skipCache: true }));
            setIsLoadDate(false);
            setSelectedTask({});
          }, 900);
        }
      },
    );
  };

  const handleOwnerChange = (value, rowdata) => {
    setIsLoadOwner(true);
    setSelectedTask(rowdata);
    dispatch(tasksUpdation({ ...rowdata, owner: value?.code })).then(
      ({ payload }) => {
        if (payload?.status) {
          setTimeout(() => {
            dispatch(fetchMilestones({ id, skipCache: true }));
            setIsLoadOwner(false);
            setSelectedTask({});
          }, 900);
        }
      },
    );
  };

  const fetchCommentList = async (task, page = 1) => {
    setSelectedTask(task);
    setIsCommentLoading(true);
    if (page == 1) {
      setCommentList([]);
    }
    try {
      const { data } = await apiService(API_ROUTES.FETCH_COMMENTS, "GET", {
        replace: {
          taskId: task.id,
          page: page || 1,
        },
        schema: z.object({
          page: z.number().optional(),
        }),
      });

      setTotalCommentCount(data.count);
      setCommentList((prev) =>
        page === 1 ? data.comments : [...prev, ...data.comments],
      );
      setHasMoreComments(
        data.comments.length > 0 && data.comments.length < data.count,
      );
      setCommentListPage(page);
      setIsCommentLoading(false);
    } catch (err) {
      setIsCommentLoading(false);
    }
  };

  return {
    taskstates: {
      isTaskUpdateLoad,
      flagForm,
      isaddflagmodal,
      isUnflagload,
      isremoveFlag,

      selectedOwners,
      selectedStatuses,
      selectedTask,
      dueDate,
      isMenuOpen,
      isLoadStatus,
      isLoadDate,
      isLoadOwner,
      flag_comment,
      isTaskCommentModal,
      taskCommentData,
      isCommentsLoading,
      isSuccessComment,
      isCommentError,
      totalCommentCount,
      isCommentLoading,
      commentList,
      hasMoreComments,
      commentListPage,
      setIsCommentError,
    },
    taskUpdate,
    removeFlagTaskUpdate,
    handleCloseFlagModal,
    handleAddFlag,
    handleChangeFlag,

    setSelectedOwners,
    setSelectedStatuses,
    setSelectedTask,
    setDueDate,
    setIsMenuOpen,
    handleStatusChange,
    handleDueDateChange,
    handleOwnerChange,
    handleMarkedAsComplete,
    addTaskCommentModalHandler,
    closeTaskCommentModalHandler,
    taskCommentChangeHandler,
    addTaskComment,
    fetchCommentList,
    files,
    setFiles,
    errorMessage,
    setErrorMessage,
    setIsTaskCommentModal,
    showAttachmentConfirmation,
    setShowAttachmentConfirmation,
    isRejectPayslip,
    setIsRejectPayslip,
    showInitialCard,
    setShowInitialCard,
  };
}

export default useTasks;
